import script from "./ArchiveModeSwitch.vue?vue&type=script&setup=true&lang=js"
export * from "./ArchiveModeSwitch.vue?vue&type=script&setup=true&lang=js"

import "./ArchiveModeSwitch.vue?vue&type=style&index=0&id=152c7785&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-152c7785"]])

export default __exports__